var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 29H10c-3.86 0-7-3.14-7-7V10c0-3.86 3.14-7 7-7h12c3.86 0 7 3.14 7 7v12c0 3.86-3.14 7-7 7ZM10 5c-2.76 0-5 2.24-5 5v12c0 2.76 2.24 5 5 5h12c2.76 0 5-2.24 5-5V10c0-2.76-2.24-5-5-5H10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.04 22.98c-1.81 0-3.59-.71-4.93-2.06a7.043 7.043 0 0 1-1.3-8.11c.83-1.67 2.25-2.91 4.02-3.5s3.65-.46 5.32.37a6.986 6.986 0 0 1 3.79 5.18c0 .03.01.06.02.08a7.024 7.024 0 0 1-3.76 7.3c-1 .51-2.08.76-3.15.76Zm.01-12.05c-.53 0-1.07.09-1.59.26a4.922 4.922 0 0 0-2.87 2.5c-.97 1.94-.59 4.28.93 5.82a4.926 4.926 0 0 0 5.75.93c1.9-.97 2.98-3.03 2.7-5.14 0-.03-.01-.06-.02-.09a4.978 4.978 0 0 0-4.92-4.28ZM22.6 10.4a.99.99 0 0 1-.71-.29c-.09-.1-.17-.21-.22-.33-.05-.12-.07-.25-.07-.38s.02-.26.07-.38c.06-.13.13-.23.22-.33.09-.09.2-.16.33-.21.36-.16.81-.07 1.08.21.1.1.17.2.22.33.05.12.08.25.08.38s-.03.26-.08.38-.12.23-.22.33c-.09.09-.2.16-.32.21-.12.05-.25.08-.38.08Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.60478415ea6aa69c25dc16512e0243af.svg";
export { ForwardRef as ReactComponent };